import { render, staticRenderFns } from "./GeneralFinancialOverview.vue?vue&type=template&id=38a5f9c8&"
import script from "./GeneralFinancialOverview.vue?vue&type=script&lang=js&"
export * from "./GeneralFinancialOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports